import baseUrl from './base';

export const getModesReglements = () => `${baseUrl}/modesReglements`;
